export const TICKET_VALIDATION_FULL = 'FULL';
